import React from 'react';
import PropTypes from 'prop-types';

// reason of creating: goo.gl/YMZBM6

const TabProvider = ({ route: { Tab }, params, data }) => (
    Tab && <Tab data={data} params={params} />
);

TabProvider.propTypes = {
    route: PropTypes.shape({
        Tab: PropTypes.func,
    }),
    params: PropTypes.shape({
        type: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        tab: PropTypes.string,
    }),
    /* eslint react/forbid-prop-types:0 */
    data: PropTypes.object,
};

export default TabProvider;



// WEBPACK FOOTER //
// ./src/js/shared/providers/TabProvider.jsx